import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, onSnapshot, query, where, doc, setDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import '../styles.css';
import LikeButton from './LikeButton';
import Lightbox from './Lightbox';

const Gallery = () => {
    const navigate = useNavigate();
    const { series } = useParams();
    const { isAdmin } = useAuth();
    // Sample images for each category
    const landscapeImages = [
        { src: "/TzofitPaintings/Landscape/Landscape48x72.jpg", description: "Acrylic on Canvas 72 x 48 inches", loading: "lazy" },
        { src: "/TzofitPaintings/Abstract/Acrylic_on_wood_panel_30x40_(76x101_cm).jpg", description: "Acrylic on Wood Panel 30 x 40 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/EcocalypseAcryliconCanvas60x72in(150x180cm).jpg", description:"Ecoalpyse Arcylic on Canvas 60 x 72 inches (150 x 180 cm)", loading: "lazy"},
        
        { src: "/TzofitPaintings/Landscape/IMG_8027.jpeg", description: "Acrylic on Canvas 48 x 36 inches", loading: "lazy" }, // No description, fallback to filename
        { src: "/TzofitPaintings/Abstract/IMG_8584.jpg", description: "Acrylic on Canvas 72 x 48 inches", loading: "lazy" },
        { src: "/TzofitPaintings/Landscape/Landscape.jpg", description: "Acrylic on Canvas 36 x 48 inches", loading: "lazy" },
        { src: "/TzofitPaintings/Landscape/AcryliconCanvas10x20inches.jpeg", description: "Acrylic on Canvas 10 x 20 inches (Sold)", loading: "lazy" },

        { src: "/TzofitPaintings/Abstract/Acrylic_on_canvas_24x36in.jpg", description: "Acrylic on Canvas 24 x 36 inches", loading: "lazy" },

        
    ];
    
    const patternImages = [
            { src: "/TzofitPaintings/Patterns/patterns1.jpg", description: "Acrylic on Canvas", title: "A Figure in Orange" },

        ];


    const realmsImages = [
        { src: "/TzofitPaintings/Realms/RealmsAcryliconCanvas60x72in(150x180cm).jpeg", description: "Acrylic on Canvas 60 x 72 inches (150 x 180 cm)" },
        { src: "/TzofitPaintings/Realms/Acryliconcanvas10x20in(25x50cm)3.jpeg", description: "Acrylic on Canvas 10 x 10 inches (25 x 50 cm)" },
        { src: "/TzofitPaintings/Realms/Acryliconwoodpanel24x36in(60x90cm).jpg", description: "Acrylic on wood panel 24 x 36 inches (60 x 90 cm)" }
        
    ];
    const abstractImages = [
        { src:  "/TzofitPaintings/Abstract/abstractBlue.jpeg", description:"Arcylic on Canvas 36x 48 inches", loading: "lazy"},
        { src:  "/TzofitPaintings/Abstract/IMG_8645.jpg", description:"Arcylic on Canvas 30 x 40 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acrylic_on_wood_panel_11x15in.jpg", description:"Acrylic on Wood Panel 11 x 15 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acrylic_on_wood_panel_30x40in_(76x101_cm)_heic.jpg", description:"Acrylic on Wood Panel 30 x 40 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acrylic_on_wood_panel_30x40in_(76x101_cm)heic.jpg", description:" Acrylic on Wood Panel 30 x 40 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_7694.jpg", description:"Acrylic on Canvas 18 x 36 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_7699.jpg", description:"Acrylic on Canvas 10 x 20 inches (25 x 50 cm)", loading: "lazy"},
        { src:  "/TzofitPaintings/Abstract/IMG_7735.jpg", description:"Acrylic on Paper 17 x 20.5 inches "},
        { src: "/TzofitPaintings/Abstract/IMG_7737.jpg", description:"Acrylic on Paper 22 x 30 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8003.jpeg", description:"Acrylic on Canvas 16 x 20 inches ", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8009.jpg", description:"Arcylic on Canvas 16 x 20 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8059.jpeg", description:"Arcylic on Canvas 72 x 48 inches", loading: "lazy"},

        { src: "/TzofitPaintings/Abstract/IMG_8014.jpeg", description:"Arcylic on Woon Panel 24 x 36 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8019.jpg", description:"Arcylic on Canvas", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8039.jpeg", description:"Arcylic on Canvas 48 x 72 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8062.jpeg", description:"Arcylic on Canvas 18 x 36 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_8074.jpeg", description:"Arcylic on Canvas 8 x 12 inches", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acrylic_on_canvas_10x20in_(25x50_cm).jpg", description:"Acrylic on Canvas 10 x 20 inches (25 x 50 cm)", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acryliconcanvas10x20in.(25x50cm)copy.jpg", description:"Acrylic on Canvas 10 x 20 inches (25 x 50 cm)", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/Acryliconcanvas10x20in(25x50cm)2.jpeg", description:"Acrylic on Canvas 10 x 20 inches (25 x 50 cm)", loading: "lazy"},
        { src: "/TzofitPaintings/Abstract/IMG_7675.jpg", description:"Acrylic on Canvas 10 x 20 inches (25 x 50 cm)", loading: "lazy"},

    
    ];

    // State to track which gallery is currently active
    const [activeGallery, setActiveGallery] = useState('figurative-art');
    const defaultSections = ['landscape', 'abstract', 'realms', 'patterns'];
    const [sections, setSections] = useState(defaultSections);
    const [metaMap, setMetaMap] = useState({}); // src -> { description }
    const [editingOpen, setEditingOpen] = useState({}); // src -> bool
    const [editingDesc, setEditingDesc] = useState({}); // src -> string

    // Sync active gallery with URL param
    useEffect(() => {
        const valid = sections;
        if (series && valid.includes(series)) {
            setActiveGallery(series);
        } else {
            setActiveGallery('figurative-art');
        }
    }, [series, sections]);

    // Load dynamic sections from Firestore in real-time
    useEffect(() => {
        const unsub = onSnapshot(collection(db, 'gallerySections'), (snap) => {
            const dynamic = snap.docs
                .map(d => {
                    const data = d.data();
                    const slug = (data.slug || (data.name || '')).toLowerCase();
                    return slug;
                })
                .filter(Boolean);
            // New sections first (most recent by createdAt won't be known here; order by arrival)
            const core = new Set(defaultSections);
            const newOnes = dynamic.filter(s => !core.has(s));
            const merged = Array.from(new Set([...newOnes, ...defaultSections]));
            setSections(merged);
        }, () => setSections(defaultSections));
        return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Load image meta overrides (descriptions) in real-time
    useEffect(() => {
        const unsub = onSnapshot(collection(db, 'imageMeta'), (snap) => {
            const map = {};
            snap.forEach(d => {
                const data = d.data() || {};
                if (data.src) map[data.src] = data;
            });
            setMetaMap(map);
        });
        return () => unsub();
    }, []);

    const safeId = useMemo(() => (src) => {
        let hash = 5381;
        for (let i = 0; i < src.length; i += 1) {
            hash = ((hash << 5) + hash) + src.charCodeAt(i);
            hash &= 0xffffffff;
        }
        return `img_${(hash >>> 0).toString(16)}`;
    }, []);

    // Note: Simplify class for consistent sizing; avoid synchronous image probing
    const getImageClass = () => 'landscape';
    // Function to extract description from image filename
    const getDescriptionFromFilename = (filename) => {
        const parts = filename.split('/').pop().split('.'); // Get the name without the extension
        let title = parts[0]; // Extract the file name (without extension)

        // Handle common separators like underscores and dashes
        title = title.replace(/[_-]/g, ' '); 

        // Handle camelCase and PascalCase by adding spaces between words
        title = title.replace(/([a-z])([A-Z])/g, '$1 $2');

        // If no title can be determined, fall back to 'Untitled'
        return title.length > 0 ? title : 'Untitled';
    };

    // Render images for the selected category
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const renderImages = (images) => {
        const slideshowImages = images.map(img => ({ src: img.src, description: metaMap[img.src]?.description || img.description || getDescriptionFromFilename(img.src) }));
        return (
            <div className="image-grid">
                {images.map((image, index) => (
                    <div className="image-item" key={index}>
                        <img
                            src={image.src}
                            alt={`Painting ${index + 1}`}
                            className={`gallery-image ${getImageClass(image.src)}`}
                            onClick={() => { setLightboxIndex(index); setLightboxOpen(true); }}
                            style={{ cursor: 'zoom-in' }}
                        />
                        <h4 className="image-title">{image.title}</h4>
                        <p className="image-description">
                            {metaMap[image.src]?.description || image.description || getDescriptionFromFilename(image.src)}
                        </p>
                        {isAdmin && (
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 4 }}>
                                {!editingOpen[image.src] && (
                                    <button className="btn-outline" onClick={() => {
                                        setEditingOpen({ ...editingOpen, [image.src]: true });
                                        setEditingDesc({ ...editingDesc, [image.src]: metaMap[image.src]?.description || image.description || '' });
                                    }}>Edit description</button>
                                )}
                                {editingOpen[image.src] && (
                                    <div style={{ display: 'grid', gap: 6, width: '100%', maxWidth: 520 }}>
                                        <input
                                            type="text"
                                            value={editingDesc[image.src] || ''}
                                            onChange={(e) => setEditingDesc({ ...editingDesc, [image.src]: e.target.value })}
                                            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb' }}
                                        />
                                        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                                            <button className="btn-submit" onClick={async () => {
                                                try {
                                                    const id = safeId(image.src);
                                                    await setDoc(doc(db, 'imageMeta', id), { src: image.src, description: (editingDesc[image.src] || '').trim() }, { merge: true });
                                                    setEditingOpen({ ...editingOpen, [image.src]: false });
                                                } catch {}
                                            }}>Save</button>
                                            <button className="btn-outline" onClick={() => setEditingOpen({ ...editingOpen, [image.src]: false })}>Cancel</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        <LikeButton imageKey={image.src} />
                    </div>
                ))}
                <Lightbox isOpen={lightboxOpen} images={slideshowImages} startIndex={lightboxIndex} onClose={() => setLightboxOpen(false)} />
            </div>
        );
    };

    return (
        <section id="gallery" className="section gallery-section">
            <h2 className="gallery-title"> Series </h2>

            {/* Navigation Buttons */}
            <div className="scroll-navigation">
                {sections.map((s) => (
                    <button key={s} onClick={() => navigate(`/gallery/${s}`)}>
                        {s.charAt(0).toUpperCase() + s.slice(1)}
                    </button>
                ))}
            </div>

            <br />
            <br />

            {/* Gallery Rendering - Try dynamic first, fallback to static */}
            <DynamicSection section={activeGallery} fallback={{
                landscape: landscapeImages,
                abstract: abstractImages,
                realms: realmsImages,
                patterns: patternImages
            }} renderImages={renderImages} />
        </section>
    );
};

export default Gallery;

// Dynamic subsection that fetches images from Firestore if available
const DynamicSection = ({ section, fallback, renderImages }) => {
    const [images, setImages] = useState(null);
    const [label, setLabel] = useState('');

    useEffect(() => {
        const fetch = async () => {
            try {
                const qs = query(collection(db, 'galleryImages'), where('section', '==', section));
                const snap = await getDocs(qs);
                const data = snap.docs.map(d => d.data());
                if (data.length > 0) {
                    setImages(data);
                } else {
                    setImages(null);
                }
                setLabel(section.charAt(0).toUpperCase() + section.slice(1));
            } catch (e) {
                setImages(null);
                setLabel(section.charAt(0).toUpperCase() + section.slice(1));
            }
        };
        fetch();
    }, [section]);

    const source = images && images.length > 0 ? images : fallback[section] || [];

    return (
        <div className="gallery-section-title">
            <h3>{label}</h3>
            {renderImages(source)}
        </div>
    );
};